import React from 'react';
import { CommonLabeledRadioInputProps } from '../../../types/common';
import OuterLabel from '../OuterLabel';
import RadioButton from '../RadioButton';
import ErrorLabel from '../ErrorLabel';

export const LabeledRadioButtonTestId = 'labeledradio-input';

export type LabeledRadioButtonProps = CommonLabeledRadioInputProps & {
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
};

const LabeledRadioButton: React.FC<LabeledRadioButtonProps> = ({
  name,
  label,
  children,
  checked,
  errorLabel,
  className = '',
  inputClassName,
  labelClassName,
  defaultChecked,
  register,
  value,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyDown,
}: LabeledRadioButtonProps) => {
  return (
    <div className={`m-2 ${className}`} data-testid={LabeledRadioButtonTestId}>
      <div className="flex flex-row items-center space-x-4">
        <RadioButton
          name={name}
          hasErrors={!!errorLabel}
          className={inputClassName}
          register={register}
          value={value}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onClick={onClick}
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={onChange}
        />
        {children}
        {!children && (
          <OuterLabel
            inputName={`${name}-${value}`}
            hasErrors={false}
            className={`ml-2 ${labelClassName}`}
          >
            {label}
          </OuterLabel>
        )}
      </div>
      <div>
        <ErrorLabel>{errorLabel}</ErrorLabel>
      </div>
    </div>
  );
};

export default LabeledRadioButton;
